import { Component } from '@angular/core';

@Component({
    selector: 'aimo-not-found',
    templateUrl: './aimo-not-found.component.html',
    standalone: false
})
export class AimoNotFoundComponent {}
